export const TRIAD_CHORDS = {
    C: { I: "C", II: "Dm", III: "Em", IV: "F", V: "G", VI: "Am", VII: "Bm" },
    G: { I: "G", II: "Am", III: "Bm", IV: "C", V: "D", VI: "Em", VII: "F#m" },
    D: { I: "D", II: "Em", III: "F#m", IV: "G", V: "A", VI: "Bm", VII: "C#m" },
    A: { I: "A", II: "Bm", III: "C#m", IV: "D", V: "E", VI: "F#m", VII: "G#m" },
    E: { I: "E", II: "F#m", III: "G#m", IV: "A", V: "B", VI: "C#m", VII: "D#m" },
    B: { I: "B", II: "C#m", III: "D#m", IV: "E", V: "F#", VI: "G#m", VII: "A#m" },
    "F#": { I: "F#", II: "G#m", III: "A#m", IV: "B", V: "C#", VI: "D#m", VII: "Fm" },
    F: { I: "F", II: "Gm", III: "Am", IV: "Bb", V: "C", VI: "Dm", VII: "Em" },
    Bb: { I: "Bb", II: "Cm", III: "Dm", IV: "Eb", V: "F", VI: "Gm", VII: "Am" },
    Eb: { I: "Eb", II: "Fm", III: "Gm", IV: "Ab", V: "Bb", VI: "Cm", VII: "Dm" },
    Ab: { I: "Ab", II: "Bbm", III: "Cm", IV: "Db", V: "Eb", VI: "Fm", VII: "Gm" },
    Db: { I: "Db", II: "Ebm", III: "Fm", IV: "Gb", V: "Ab", VI: "Bbm", VII: "Cm" },
    Gb: { I: "Gb", II: "Abm", III: "Bbm", IV: "Cb", V: "Db", VI: "Ebm", VII: "Fm" },

    Am: { I: "Am", II: "Bm", III: "C", IV: "Dm", V: "Em", VI: "F", VII: "G" },
    Em: { I: "Em", II: "F#m", III: "G", IV: "Am", V: "Bm", VI: "C", VII: "D" },
    Bm: { I: "Bm", II: "C#m", III: "D", IV: "Em", V: "F#m", VI: "G", VII: "A" },
    "F#m": { I: "F#m", II: "G#m", III: "A", IV: "Bm", V: "C#m", VI: "D", VII: "E" },
    "C#m": { I: "C#m", II: "D#m", III: "E", IV: "F#m", V: "G#m", VI: "A", VII: "B" },
    "G#m": { I: "G#m", II: "A#m", III: "B", IV: "C#m", V: "D#m", VI: "E", VII: "F#" },
    "D#m": { I: "D#m", II: "E#m", III: "F", IV: "G#m", V: "A#m", VI: "B", VII: "C#" },
    Dm: { I: "Dm", II: "Em", III: "F", IV: "Gm", V: "Am", VI: "Bb", VII: "C" },
    Gm: { I: "Gm", II: "Am", III: "Bb", IV: "Cm", V: "Dm", VI: "Eb", VII: "F" },
    Cm: { I: "Cm", II: "Dm", III: "Eb", IV: "Fm", V: "Gm", VI: "Ab", VII: "Bb" },
    Fm: { I: "Fm", II: "Gm", III: "Ab", IV: "Bbm", V: "Cm", VI: "Db", VII: "Eb" },
    Bbm: { I: "Bbm", II: "Cm", III: "Db", IV: "Ebm", V: "Fm", VI: "Gb", VII: "Ab" },
    Ebm: { I: "Ebm", II: "Fm", III: "Gb", IV: "Abm", V: "Bbm", VI: "Cb", VII: "Db" }
};